import React,{useState} from 'react'
import PageHeader from '../../Components/Instructor_Dashboard/PageHeader'
import ThumbnailUploader from '../../Components/ThumbnailUploader';
import { Link } from 'react-router-dom';
import { DatePicker,Inn } from 'antd';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Curriculum_Card from '../../Components/Courses/Curriculum_Card';

import {
    Button,
    Checkbox,
    Select,
    Switch,
    Input,
    Form,
    Tabs,
    Radio,
    Space,
    Tag,
    Col,
    Row,
    Table
  } from "antd";
  import {
    HomeOutlined,
    InfoCircleOutlined,
    PayCircleOutlined,
    CameraOutlined,
    SearchOutlined,
    CheckCircleOutlined,
    PlusOutlined,
    MinusOutlined,
    ArrowRightOutlined,
    
  } from "@ant-design/icons";
import { useLocation } from 'react-router-dom';

  
  const { TabPane } = Tabs;
  const { Option } = Select;
  const { TextArea } = Input;
  dayjs.extend(customParseFormat);


  const columns = [
    {
      title: 'Student',
      dataIndex: 'student',
      key: 'student',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Progress',
      dataIndex: 'progress',
      key: 'progress',
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      render: (_, record) => (
        <button onClick={() => console.log('Edit clicked for:', record.student)}>
          Edit
        </button>
      ),
    },
  ];
  
  const data = [
    {
      key: '1',
      student: 'John Brown',
      date: '2025-02-07', // Example date format, change as needed
      progress: 'In Progress',
      actions: 'edit', // Optional, but handled in render of actions column
    },
  ];

const AddCourse = () => {
    const [form] = Form.useForm();
    const [value, setValue] = useState(1);
    const [valueforExpiry, setValueforExpiry] = useState(1);
    const [checked, setChecked] = useState(false);
    const [isCheckedForFreeCourse, setIsCheckedForFreeCourse] = useState(false);
    const [tags, setTags] = useState([]);
    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [faqList, setFaqList] = useState([{ question: "", answer: "" }]);
    const [requirementList, setRequirementList] = useState([{ requirement: "" }]);
    const [outcomesList, setOutcomesList] = useState([{ outcomes: "" }]);
    const [editorContent, setEditorContent] = useState("");

    const location = useLocation()

    console.log(location)
  
    const onChange = (e) => {

      console.log("radio checked", e.target.value);
      setValue(e.target.value);
    };
  
    const onChangeForExpiry = (e) => {
      console.log("radio checked", e.target.value);
      setValueforExpiry(e.target.value);
    };
  
    const handleClose = (removedTag) => {
      setTags(tags.filter((tag) => tag !== removedTag));
    };
  
    const handleInputConfirm = () => {
      if (inputValue && !tags.includes(inputValue)) {
        setTags([...tags, inputValue]);
      }
      setInputVisible(false);
      setInputValue("");
    };
  
    const onChangeRadiobtn = (checked) => {
      setChecked(checked);
      console.log("Switch is now:", checked ? "ON" : "OFF");
    };
  
    const handleCheckboxChangeForFreeCourse = (e) => {
      setIsCheckedForFreeCourse(e.target.checked);
    };
  
    const onFinish = (values) => {
      console.log("Success:", values);
    };
  
    const handleAdd = () => {
      setFaqList([...faqList, { question: "", answer: "" }]);
    };
  
    const handleRemove = (index) => {
      const updatedFaqList = faqList.filter((_, i) => i !== index);
      setFaqList(updatedFaqList);
    };
  
    const handleAddRequirement = () => {
      setRequirementList([...requirementList, { requirement: "" }]);
    };
  
    const handleRemoveRequirement = (index) => {
      const updatedRequirementList = requirementList.filter(
        (_, i) => i !== index
      );
      setRequirementList(updatedRequirementList);
    };
    const handleAddOutcomes = () => {
      setOutcomesList([...outcomesList, { requirement: "" }]);
    };
  
    const handleRemoveOutcomes = (index) => {
      const updatedOutcomes = outcomesList.filter((_, i) => i !== index);
      setOutcomesList(updatedOutcomes);
    };
  
    const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
    };


  return (
    <div className='add_course_page'>
        <PageHeader title={'Add new course'}/>
        <div className='add_course_div'>
            Add Course

            <div>
            <Tabs defaultActiveKey="1">

                {  location.pathname === '/user/edit_course' && 
                    <>
                       {/* Curriculum tab */}
                        <TabPane
                            tab={
                                <span>
                                <HomeOutlined /> Curriculum
                                </span>
                            }
                            key="15"
                        >

                           <div className='curriculum_div'>
                             <div>
                                <button className='curriculum_top_btn'><PlusOutlined /> Add section</button>
                                <button className='curriculum_top_btn'><PlusOutlined />Add lesson</button>
                                <button className='curriculum_top_btn'><PlusOutlined />Add quiz</button>
                                <button className='curriculum_top_btn'>Sort sections</button>
                             </div>
                            <Curriculum_Card /> 
                           </div>

                        </TabPane>


                        {/* Academic  progress tab */}
                        <TabPane
                            tab={
                                <span>
                                <HomeOutlined /> Academic progress
                                </span>
                            }
                            key="16"
                        >

                           <Table columns={columns} dataSource={data}/>

                        </TabPane>

                        {/* bbc live tab */}

                        <TabPane
                            tab={
                                <span>
                                <HomeOutlined /> Bbb Live class
                                </span>
                            }
                            key="17"
                        >

                        <div className='bbc_live_tab'>
                           <div className='bbc_live_left'>
                              <div>
                                <p>Meeting id</p>
                                <Input className='bbc_input_box' />
                              </div>
                              <div>
                                <p>Moderator password</p>
                                <Input className='bbc_input_box' />
                              </div>
                              <div>
                                <p>Viewer password</p>
                                <Input className='bbc_input_box' />
                              </div>
                           </div>
                           <div className='bbc_live_right'>
                                 <div className='bbc_live_right_card'>
                                    <h5>Attention!</h5>
                                    <p>Give some instructions to keep your students informed about the meeting </p>
                                 </div>
                                 <button className='bbc_save_meeting_btn'>Save meeting info</button>
                                 <button className='bbc_start_meeting_btn'>start meeting</button>
                           </div>
                        </div>

                        </TabPane>
                         

                         {/* zoom live settings tab */}

                        <TabPane
                            tab={
                                <span>
                                <HomeOutlined /> Zoom live settings
                                </span>
                            }
                            key="18"
                        >

                          <div className='zoom_live_settings'>
                             <div className='zoom_live_settings_left'>
                                <div className='zoom_live_settings_left_div'>
                                    <div>
                                       <p className='zoom_live_settings_label'>Live class schedule </p>
                                       <p>(Date)</p>
                                    </div>
                                    <DatePicker className='zoom_input'/>
                                </div>

                                <div className='zoom_live_settings_left_div'>
                                    <div>
                                       <p className='zoom_live_settings_label'>Live class schedule </p>
                                       <p>(Time)</p>
                                    </div>
                                    <TimePicker  defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}  className='zoom_input'/>
                                </div>

                                <div className='zoom_live_settings_left_div'>
                                    <div>
                                       <p className='zoom_live_settings_label'>Note to students</p>
                                    </div>
                                     <TextArea rows={4} className='zoom_input'/>
                                </div>

                                <div className='zoom_live_settings_left_div'>
                                    <div>
                                       <p className='zoom_live_settings_label'>Meeting id</p>
                                    </div>
                                    <Input  />
                                </div>

                                <div className='zoom_live_settings_left_div'>
                                    <div>
                                       <p className='zoom_live_settings_label'>Meeting password</p>
                                    </div>
                                    <Input  className='zoom_input'/>
                                </div>

                             </div>
                             <div className='course_enrollment_div'>
                                <div className='zoom_meeting_plans_card'>
                                    <h4>Course enrolment details</h4>
                                    <p>Number of enrolment : <strong>2</strong></p>
                                    <hr></hr>
                                    <p>Get Zoom Meeting plans that fit your business perfectly.</p>
                                    <button className='zoom_meeting_plan_btn'>zoom meeting plans <ArrowRightOutlined /></button>
                                </div>
                                <div className='zoom_meeting_plans_card'>
                                    <p>Both the meeting ID, password, and Zoom settings must be configured from the same Zoom account. If there is more than one teacher in the course, the one who added the course will be considered the course creator. The course creator needs to configure <Link to={'/zoom_live_settings'}>Zoom Live Class settings</Link> and Zoom Live Class. </p>
                                </div>
                                <div>
                                    <button className='start_live_class_btn'>Start Live Class</button>
                                </div>
                             </div>
                          </div>
                
                        </TabPane>
                    </>
                    
                }

                {/* Basic Tab */}
                <TabPane
                  tab={
                    <span>
                      <HomeOutlined /> Basic
                    </span>
                  }
                  key="1"
                >
                  <Form
                    form={form}
                    name="basic"
                    labelCol={{
                      span: 6,
                    }}
                    wrapperCol={{
                      span: 12,
                    }}
                    initialValues={{
                      remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                  >
                    <Form.Item
                      label="Course title"
                      name="courseTitle"
                      rules={[
                        {
                          required: true,
                          message: "Please input your Course title!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item label="Short description">
                      <Input.TextArea />
                    </Form.Item>
                    <Form.Item
                      label="Course Description"
                      name="description"
                      rules={[
                        {
                          required: true,
                          message: "Please enter the course description!",
                        },
                      ]}
                    >
                      

                    </Form.Item>
                    <Form.Item
                      name="category"
                      label="Select a category"
                      rules={[
                        { required: true, message: "Please select an option!" },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Search to select"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        <Option value="1">Option 1</Option>
                        <Option value="2">Option 2</Option>
                        <Option value="3">Option 3</Option>
                        <Option value="4">Option 4</Option>
                        <Option value="5">Option 5</Option>
                      </Select>
                    </Form.Item>


                    <Form.Item
                      name="level"
                      label="Level"
                      rules={[
                        { required: true, message: "Please select an option!" },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Search to select"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        <Option value="1">Beginner</Option>
                        <Option value="2">Advanced</Option>
                        <Option value="3">Intermediate</Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      name="language"
                      label="Language made in"
                      rules={[
                        { required: true, message: "Please select an option!" },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Search to select"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        <Option value="1">English</Option>
                      </Select>
                    </Form.Item>


                    <Form.Item
                      name="switch"
                      label="Enable drip content"
                      valuePropName="checked"
                      initialValue={false}
                    >
                      <Switch
                        checked={checked}
                        onChange={onChangeRadiobtn}
                        checkedChildren="On"
                        unCheckedChildren="Off"
                      />
                    </Form.Item>

                    <Form.Item
                      name="radioGroup"
                      label="Create as a"
                      initialValue={1}
                    >
                      <Radio.Group onChange={onChange} value={value}>
                        <Space direction="vertical">
                          <Radio value={1}>Active course</Radio>
                          <Radio value={2}>Private course</Radio>
                          <Radio value={3}>Upcoming course</Radio>
                        </Space>
                      </Radio.Group>
                    </Form.Item>
                    <Form.Item name="remember" valuePropName="" label={null}>
                      <Checkbox>Check if this course is top course</Checkbox>
                    </Form.Item>
                    <Form.Item label={null}>
                      <Button type="primary" htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>

                  </Form>
                </TabPane>


                {/* Info Tab */}
                <TabPane
                  tab={
                    <span>
                      <InfoCircleOutlined /> Info
                    </span>
                  }
                  key="2"
                >
                  <Form
                    name="faq_form"
                    onFinish={onFinish}
                    autoComplete="off"
                    layout="vertical"
                  >
                    <Form.Item label="Course FAQ">
                      {faqList.map((faq, index) => (
                        <Row
                          key={index}
                          gutter={16}
                          align="middle"
                          style={{ marginBottom: "16px" }}
                        >
                          <Col span={8}></Col>
                          <Col span={12}>
                            <Form.Item
                              name={["faqList", index, "question"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please input the FAQ question!",
                                },
                              ]}
                              initialValue={faq.question}
                            >
                              <Input placeholder="Faq question" />
                            </Form.Item>
                           </Col>
                          <Col span={2}>
                            <Button
                              type="primary"
                              danger={index !== 0}
                              icon={
                                index === 0 ? (
                                  <PlusOutlined />
                                ) : (
                                  <MinusOutlined />
                                )
                              }
                              onClick={
                                index === 0
                                  ? handleAdd
                                  : () => handleRemove(index)
                              }
                              style={{ width: "100%", marginBottom: "22px" }}
                            >
                              {index === 0 ? "" : ""}
                            </Button>
                          </Col>
                          <Col span={8}></Col>
                          <Col span={12}>
                            <Form.Item
                              name={["faqList", index, "answer"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please input the FAQ answer!",
                                },
                              ]}
                              initialValue={faq.answer}
                            >
                              <Input.TextArea placeholder="Answer" rows={3} />
                            </Form.Item>
                          </Col>
                          <Col span={3}></Col>
                        </Row>
                      ))}
                    </Form.Item>

                    
                    <Form.Item label="Requirements">
                      {requirementList.map((faq, index) => (
                        <Row
                          key={index}
                          gutter={16}
                          align="middle"
                          style={{ marginBottom: "16px" }}
                        >
                          <Col span={8}></Col>
                          <Col span={12}>
                            <Form.Item
                              name={["requirement", index]}
                              rules={[
                                {
                                  required: true,
                                  message:
                                    "Please input the provide requirement!",
                                },
                              ]}
                              initialValue={faq.requirement}
                            >
                              <Input placeholder=" Provide Requirement" />
                            </Form.Item>
                          </Col>
                          <Col span={2}>
                            <Button
                              type="primary"
                              danger={index !== 0}
                              icon={
                                index === 0 ? (
                                  <PlusOutlined />
                                ) : (
                                  <MinusOutlined />
                                )
                              }
                              onClick={
                                index === 0
                                  ? handleAddRequirement
                                  : () => handleRemoveRequirement(index)
                              }
                              style={{ width: "100%", marginBottom: "22px" }}
                            >
                              {index === 0 ? "" : ""}
                            </Button>
                          </Col>
                        </Row>
                      ))}
                    </Form.Item>


                    <Form.Item label="Outcomes">
                      {outcomesList.map((faq, index) => (
                        <Row
                          key={index}
                          gutter={16}
                          align="middle"
                          style={{ marginBottom: "16px" }}
                        >
                          <Col span={8}></Col>
                          <Col span={12}>
                            <Form.Item
                              name={["outcomes", index]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please input provide outcomes!",
                                },
                              ]}
                              initialValue={faq.outcomes}
                            >
                              <Input placeholder=" Provide Outcomes" />
                            </Form.Item>
                          </Col>
                          <Col span={2}>
                            <Button
                              type="primary"
                              danger={index !== 0}
                              icon={
                                index === 0 ? (
                                  <PlusOutlined />
                                ) : (
                                  <MinusOutlined />
                                )
                              }
                              onClick={
                                index === 0
                                  ? handleAddOutcomes
                                  : () => handleRemoveOutcomes(index)
                              }
                              style={{ width: "100%", marginBottom: "22px" }}
                            >
                              {index === 0 ? "" : ""}
                            </Button>
                          </Col>
                          <Col span={8}></Col>
                        </Row>
                      ))}
                    </Form.Item>


                    <Form.Item>
                      <Button type="primary" htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                  </Form>
                </TabPane>

                {/* Pricing Tab */}
                <TabPane
                  tab={
                    <span>
                      <PayCircleOutlined /> Pricing
                    </span>
                  }
                  key="3"
                >
                  <Form
                    name="basic"
                    labelCol={{
                      span: 6,
                    }}
                    wrapperCol={{
                      span: 12,
                    }}
                    initialValues={{
                      remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                  >
                    <Form.Item name="remember" valuePropName="" label={null}>
                      <Checkbox onChange={handleCheckboxChangeForFreeCourse}>
                        Check if this is a free course
                      </Checkbox>
                    </Form.Item>
                    {!isCheckedForFreeCourse && (
                      <>
                        <Form.Item label="Course price ($)" name="coursePrice">
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="remember"
                          valuePropName="checked"
                          label={null}
                        >
                          <Checkbox>Check if this course has discount</Checkbox>
                        </Form.Item>

                        <Form.Item
                          label="Discounted price"
                          name="discountedPrice"
                        >
                          <Input />
                        </Form.Item>
                      </>
                    )}
                    <Form.Item
                      name="radioGroup"
                      label="Expiry period"
                      initialValue={1} // Default value is "Lifetime"
                    >
                      <Radio.Group
                        onChange={onChangeForExpiry}
                        value={valueforExpiry}
                      >
                        <Space direction="horizontal">
                          <Radio value={1}>Lifetime</Radio>
                          <Radio value={2}>Limited time</Radio>
                        </Space>
                      </Radio.Group>
                    </Form.Item>
                    {valueforExpiry === 2 && (
                      <>
                        <Form.Item
                          label="Number of months"
                          name="courseDuration"
                        >
                          <Input />
                        </Form.Item>

                        <Form.Item>
                          <label>
                            After purchase, students can access the course until
                            your selected time.
                          </label>
                        </Form.Item>
                      </>
                    )}

                    <Form.Item label={null}>
                      <Button type="primary" htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                  </Form>
                </TabPane>

                {/* Media Tab */}
                <TabPane
                  tab={
                    <span>
                      <CameraOutlined /> Media
                    </span>
                  }
                  key="4"
                >
                  <Form
                    name="basic"
                    labelCol={{
                      span: 6,
                    }}
                    wrapperCol={{
                      span: 12,
                    }}
                    initialValues={{
                      remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                  >
                    <Form.Item label="Course overview provider">
                      <Select
                        showSearch
                        placeholder="Search to select"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        <Option value="1">Youtube</Option>
                        <Option value="2">Vimeo</Option>
                        <Option value="3">HTML5</Option>
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="Course overview url"
                      name="url"
                      rules={[
                        {
                          required: true,
                          message: "Please input your Course title!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <ThumbnailUploader
                      name="thumbnail"
                      label="Course Thumbnail"
                      required={true}
                      onChange={(file) => console.log("Uploaded File:", file)}
                    />
                  </Form>
                </TabPane>

                {/* SEO Tab */}
                <TabPane
                  tab={
                    <span>
                      <SearchOutlined /> SEO
                    </span>
                  }
                  key="5"
                >
                  <Form
                    name="basic"
                    labelCol={{
                      span: 6,
                    }}
                    wrapperCol={{
                      span: 12,
                    }}
                    initialValues={{
                      remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                  >
                    <Form.Item
                      label="Meta Keywords"
                      name="keywords"
                      rules={[
                        {
                          required: true,
                          message: "Please add at least one keyword",
                        },
                      ]}
                    >
                      <>
                        <div
                          style={{
                            border: "1px solid #d9d9d9",
                            padding: "4px",
                            borderRadius: "4px",
                            minHeight: "40px",
                          }}
                        >
                          {tags.map((tag) => (
                            <Tag
                              key={tag}
                              closable
                              onClose={() => handleClose(tag)}
                              style={{ marginBottom: "4px" }}
                            >
                              {tag}
                            </Tag>
                          ))}
                          {inputVisible ? (
                            <Input
                              size="small"
                              style={{ width: "150px", marginBottom: "4px" }}
                              value={inputValue}
                              onChange={(e) => setInputValue(e.target.value)}
                              onBlur={handleInputConfirm}
                              onPressEnter={handleInputConfirm}
                              autoFocus
                            />
                          ) : (
                            <Tag
                              onClick={() => setInputVisible(true)}
                              style={{
                                background: "#fff",
                                borderStyle: "dashed",
                                cursor: "pointer",
                              }}
                            >
                              <PlusOutlined /> Add keyword
                            </Tag>
                          )}
                        </div>
                      </>
                    </Form.Item>
                    <Form.Item label="Meta description">
                      <Input.TextArea />
                    </Form.Item>
                  </Form>
                </TabPane>

                {/* Finish Tab */}
                <TabPane
                  tab={
                    <span>
                      <CheckCircleOutlined /> Finish
                    </span>
                  }
                  key="6"
                >
                  <div className="finish_tab">
                    <h5>Thank you</h5>
                    <p className="finish_tag">You are just one click away</p>
                    <button className="finish_submit_btn">Submit</button>
                  </div>
                </TabPane>
              </Tabs>
            </div>
        </div>
    </div>
  )
}

export default AddCourse
